// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-generate-preview {
  visibility: hidden;
  position: absolute;
  left: 0px;
  top: -10000px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document/document-generate-preview/document-generate-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AACJ","sourcesContent":[".fi-document-generate-preview {\r\n    visibility: hidden;\r\n    position: absolute;\r\n    left: 0px;\r\n    top: -10000px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
